
import React from 'react';
import { Link } from 'react-router-dom';

const FooterLogo: React.FC = () => {
  return (
    <div>
      <div className="mb-4">
        <Link to="/" className="inline-flex items-center font-bold">
          <span className="text-2xl text-purple-600">OGM</span>
          <span className="text-2xl text-white px-1.5 py-0.5 rounded-lg bg-purple-600">AI</span>
        </Link>
      </div>
      <p className="text-gray-400 mb-4">
        Discover, share, and use AI agents created by developers and enthusiasts around the world.
      </p>
    </div>
  );
};

export default FooterLogo;
